import { Component, OnDestroy, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { MessageService, FilterMetadata } from 'primeng/api';
import { from, Subscription, Observable, Subject, EMPTY } from 'rxjs';
import { map, switchMap, debounceTime, concatMap, finalize, catchError, takeUntil } from 'rxjs/operators';

import { Table } from 'primeng/table';
import { FilterService, MenuItem } from 'primeng/api';

import { environment } from 'src/environments/environment';

import { Product, ProductListFetchParams } from 'src/app/shared/product'
import { ProductGroup } from 'src/app/shared/product-group'

import { GlobalSettingsData } from 'src/app/shared/global-settings-data'
import { GetglobalsettingsService } from 'src/app/services/getglobalsettings.service'
import { ProductApiService } from 'src/app/services/product-api.service';
import { RestApiService } from 'src/app/services/rest-api.service';

export interface Column {
  field: string;
  header: string;
  nonhide: boolean;
  show: boolean;
  filter: boolean;
};

@Component({
  selector: 'app-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ProductListComponent implements OnInit, OnDestroy, OnChanges {
  private globalSettinsData: GlobalSettingsData;

  columns: Column[] = [
    { field: 'PRODCODE', header: 'Код товара', nonhide: true, show: true, filter: true },
    { field: 'PRODBARCODEMASK', header: 'EAN/UPC', nonhide: false, show: false, filter: true },
    { field: 'PRODCUSTCODE', header: 'Код УКТЗЕД', nonhide: false, show: false, filter: true },
    { field: 'PRODARTICUL', header: 'Артикул', nonhide: false, show: false, filter: true },
    { field: 'PRODNAME', header: 'Наименование товара', nonhide: false, show: true, filter: true },
    { field: 'PRODDESCRIPTION', header: 'Описание товара', nonhide: false, show: false, filter: true },
    { field: 'PRODNOTE', header: 'Примечание', nonhide: false, show: false, filter: true },
    { field: 'PRODCATEGORY', header: 'Категория', nonhide: false, show: false, filter: true },
    { field: 'PRODGROUPNAME', header: 'Группа', nonhide: false, show: false, filter: true },
    { field: 'PRODVENDORNAME', header: 'Производитель', nonhide: false, show: false, filter: true },
    { field: 'PRODPRICEUAH', header: 'Цена', nonhide: true, show: true, filter: true },
    { field: 'PRODPRICEUSD', header: 'В валюте', nonhide: false, show: true, filter: true },
    { field: 'PRODSTOCK', header: 'Склад', nonhide: false, show: true, filter: true },
  ];

  public get visiblePRODCODEColumn(): boolean { return this._visibleColumn('PRODCODE') }
  public get visiblePRODARTICULColumn(): boolean { return this._visibleColumn('PRODARTICUL') }
  public get visiblePRODCUSTCODEColumn(): boolean { return this._visibleColumn('PRODCUSTCODE') }
  public get visiblePRODBARCODEMASKColumn(): boolean { return this._visibleColumn('PRODBARCODEMASK') }
  public get visiblePRODNAMEColumn(): boolean { return this._visibleColumn('PRODNAME') }
  public get visiblePRODDESCRIPTIONColumn(): boolean { return this._visibleColumn('PRODDESCRIPTION') }
  public get visiblePRODNOTEColumn(): boolean { return this._visibleColumn('PRODNOTE') }
  public get visiblePRODCATEGORYColumn(): boolean { return this._visibleColumn('PRODCATEGORY') }
  public get visiblePRODGROUPNAMEColumn(): boolean { return this._visibleColumn('PRODGROUPNAME') }
  public get visiblePRODVENDORNAMEColumn(): boolean { return this._visibleColumn('PRODVENDORNAME') }
  public get visiblePRODPRICEUAHColumn(): boolean { return this._visibleColumn('PRODPRICEUAH') }
  public get visiblePRODPRICEUSDColumn(): boolean { return this._visibleColumn('PRODPRICEUSD') }
  public get visiblePRODSTOCKColumn(): boolean { return this._visibleColumn('PRODSTOCK') }

  private _visibleColumn(name: string): boolean {
    let col: Column = this.selectedColumns.find(e => e.field == name);
    //console.log('*** ProductListComponent _visibleColumn ' + name + ' (selection): ' + JSON.stringify(col));
    return (col) ? true : false;
  }

  public get filterPRODCODEColumn(): boolean { return this._filterColumn('PRODCODE') }
  public get filterPRODCUSTCODEColumn(): boolean { return this._filterColumn('PRODCUSTCODE') }
  public get filterPRODBARCODEMASKColumn(): boolean { return this._filterColumn('PRODBARCODEMASK') }
  public get filterPRODARTICULColumn(): boolean { return this._filterColumn('PRODARTICUL') }
  public get filterPRODNAMEColumn(): boolean { return this._filterColumn('PRODNAME') }
  public get filterPRODDESCRIPTIONColumn(): boolean { return this._filterColumn('PRODDESCRIPTION') }
  public get filterPRODNOTEColumn(): boolean { return this._filterColumn('PRODNOTE') }
  public get filterPRODCATEGORYColumn(): boolean { return this._filterColumn('PRODCATEGORY') }
  public get filterPRODGROUPNAMEColumn(): boolean { return this._filterColumn('PRODGROUPNAME') }
  public get filterPRODVENDORNAMEColumn(): boolean { return this._filterColumn('PRODVENDORNAME') }
  public get filterPRODPRICEUAHColumn(): boolean { return this._filterColumn('PRODPRICEUAH') }
  public get filterPRODPRICEUSDColumn(): boolean { return this._filterColumn('PRODPRICEUSD') }
  public get filterPRODSTOCKColumn(): boolean { return this._filterColumn('PRODSTOCK') }

  private _filterColumn(name: string): boolean {
    let col: Column = this.columns.find(e => e.field == name);
    return (col) ? col.filter : false;
  }

  public get columnCount(): string {
    if (!this.prodTable?.columns) return '2';
    let cols = (this.prodTable.columns.length + 2).toFixed(0);
    console.log('*** ProductListComponent get columnCount: ' + cols);
    return cols;
  }

  public columnCounter(): number {

    let cols = this.prodTable.columns.length + 2;
    //    console.log('*** ProductListComponent get columnCounter: ' + cols);

    return cols;
  }

  private initialized: boolean = false;
  private currentGroupId: number;
  private _groupId: number = 202;

  /*
   Angular binding phase:  groupId setter fires → listOptions$.next() → 
                          but _prodListQuery not yet subscribed → emission lost
                          and globalSettinsData is undefined → potential crash

  ngOnInit runs later:    createProductSubscription() → now subscribed
                          listOptions$.next() → works, but groupId value was the default (202)
  */

  @Input()
  get groupId(): number {
    //    console.log('*** ProductListComponent get groupId: ' + this._groupId);
    return this._groupId;
  }

  set groupId(gv: number) {
    console.log('*** ProductListComponent set groupId:  ' + gv);
    this._groupId = gv;
    this.currentGroupId = gv;
    if (this.initialized) {
      this.listOptions$.next({ obsolete: this.showObsoleteProducts, balCurr: this.usdCurrencyId, group: this.groupId, filter: this.filters });
    }
  }

  @Input() prodId: number /*= 58644*/;

  @Input() uahCurrencyId: number = 102;
  @Input() usdCurrencyId: number = 105;

  @Input() showUSDCurrencySelector: boolean = true;

  @Input() showObsoleteProducts: number[] = [];

  showProductOptions = [
    { name: 'Акт', value: 0 },
    { name: 'Уст', value: 1 },
  ];

  @Input() showFilterHeader: boolean = true;

  @Input() initialColumnSet: string[] = [
    'PRODCODE',
    'PRODNAME',
    'PRODDESCRIPTION',
    'PRODNOTE',
    'PRODPRICEUAH',
    'PRODPRICEUSD'
  ];

  @Input()
  get selectedColumns(): Column[] {
    return this._selectedColumns;
  }

  set selectedColumns(val: Column[]) {
    //console.log('*** ProductListComponent selectedColumns setter ');
    //environment.production || console.table(this.columns);

    this._selectedColumns = [...val];
  }

  _selectedColumns: Column[] = [];

  @Input() showColumnSelector: boolean = false;

  @Input() state: string = 'product-list-state';

  @Input() showCaption: boolean = true;

  @Output() public productSelection: EventEmitter<{ current: Product, list: Product[]}> = new EventEmitter();
  @Output() public contentReady: EventEmitter<boolean> = new EventEmitter();
  @Output() public allProductList: EventEmitter<Product[]> = new EventEmitter();
  /** Emits the balance currency ID after the user picks another one in the list's own selector. */
  @Output() public usdCurrencyIdChange: EventEmitter<number> = new EventEmitter();

  /*private*/ _prodId: number;


  rowsPerPage: number[] = [10, 20, 50, 100, 500];

  public get paginatorPosition(): string { return this.rows > 20 ? "both" : "bottom"; }

  rows: number = 20;   /* for flex scroll */
  totalRecords: number;
  loading: boolean = false;

  //  product: Product = null;
  productList: Product[] = [];
  virtualList: Product[] = [];

  @ViewChild('prodTable') prodTable: Table;

  selectedProduct: Product[] = [];
  // selectedProductRow: Product = null;     // single Selection mode

  public get noSelection(): boolean {
//    environment.production || console.table(this.selectedProduct);
    return !(this.selectedProduct && this.selectedProduct.length > 0);
  }

  items: MenuItem[] = [
    {
      label: 'Устаревший...', icon: 'pi pi-ban', command: () => {
        this.doObsoleteProduct();
      }
    },
    {
      label: 'Переместить в...', icon: 'pi pi-site-map', command: () => {
        this.doMoveProduct();
      }
    },
    {
      label: 'Прозводитель...', icon: 'pi pi-user-edit', command: () => {
        this.doChangeVendorProduct();
      }
    },
    {
      label: 'Категория...', icon: 'pi pi-user-edit', command: () => {
        this.doChangeCategoryProduct();
      }
    },
    {
      label: 'Таможенный код ...', icon: 'pi pi-user-edit', command: () => {
        this.enterCodeString();
      }
    },
  ];

  selectedGroup: ProductGroup = null;

  tableHeader: string = '';

  prodCodeFilter: string;
  prodArticulFilter: string;
  prodNameFilter: string;
  prodDescFilter: string;
  prodNoteFilter: string;
  prodCategoryFilter: string;
  prodGroupFilter: string;
  prodVendorFilter: string;

  custCodeFilter: string;
  barCodeFilter: string;

  prodPriceUahFilter: number;
  prodPriceUsdFilter: number;
  prodStockBeFilter: number;

  filters: any;

  private destroy$ = new Subject<void>();

  private _groupQuery: Subscription;
  private _productQuery: Subscription;
  private _prodRowQuery: Subscription;
  private _prodGrEditQuery: Subscription;

  search$: Observable<string>;
  private listOptions$ = new Subject<{ obsolete: number[], balCurr: number, group: number, filter: any }>();

  displayGG: boolean = false;

  displaySC: boolean = false;
  codeString: string = '';

  displayGS: boolean = false;
  confirmMarkProdObsDisplay: boolean = false;
  confirmMarkProdObsConfirmation: boolean = false;

  confirmMarkProdObsText: string = 'MOVE';
  confirmMarkProdObsMessage: string = 'Отметить выбранные товары устаревшими?';
  confirmMarkProdObsHeader: string = 'Подтверждение действия с несколькими товарами';

  constructor(
    private prodApi: ProductApiService,
    private restApi: RestApiService,
    private globalsettingsservice: GetglobalsettingsService,
    private messageService: MessageService,
    private filterService: FilterService
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    //console.log('*** ProductListComponent ngOnChanges: enter');
    //environment.production || console.table(changes);
    for (let propName in changes) {
      let change = changes[propName];

      environment.production || console.log('*** ProductListComponent ngOnChanges ' + propName + ' (actual): ' + JSON.stringify(change.currentValue));
      //console.log('*** ProductListComponent ngOnChanges ' + propName + ' (was):    ' + JSON.stringify(change.previousValue));

      switch (propName) {
        case 'prodId':
          /*
           * TODO: check the groupId for new product and update information if differs
           */
          if (this.prodId) {
            this.selectedProduct = [];
            this.scrollToProductId(this.prodId);
          } 
          break;

        case 'groupId':
/*
 * Don't be fooled
 * Everything did in groupId setter :)
 */
          //console.log('*** ProductListComponent ngOnChanges: groupId ' + this.groupId);
          this._groupQuery = this.prodApi.getProdGroupById(this.groupId)
            .pipe(takeUntil(this.destroy$), map(data => {
              this.selectedGroup = data;
              this.tableHeader = this.selectedGroup.PGROUPNAME;

              //console.log('*** ProductListComponent ngOnInit get groupInfo: ' + JSON.stringify(event));
            }))
            .subscribe({
              next: () => console.log('*** ProductListComponent ngOnInit get groupInfo: '),
              error: (err) => {
                console.error('*** ProductListComponent _groupQuery error: ', err);
                this.messageService.add({ severity: 'error', summary: 'Помилка завантаження групи', detail: err?.message || 'Невідома помилка' });
              }
            });
          break;

        case 'showObsoleteProducts':
        case 'uahCurrencyId':
        case 'usdCurrencyId':
          this.listOptions$.next({
            obsolete: this.showObsoleteProducts,
            balCurr: this.usdCurrencyId,
            group: this.groupId,
            filter: this.filters
          });
          break;

        case 'state':
          // State is restored once in ngOnInit from localStorage.
          // ngOnChanges fires for 'state' only when the parent explicitly
          // rebinds the input at runtime — in that case reload with new key.
          if (!change.firstChange) {
            this.restoreStateFromStorage();
            if (this.initialized) {
              this.listOptions$.next({ obsolete: this.showObsoleteProducts, balCurr: this.usdCurrencyId, group: this.groupId, filter: this.filters });
            }
          }
          break;

        case 'initialColumnSet':
          this.columns.forEach(e => {
            e.show = e.nonhide ? true : (change.currentValue.findIndex(n => n == e.field) > -1);
          })
          //environment.production || console.table(this.columns);
          this.selectedColumns = this.columns.filter(e => e.show);

          break;
      }
    }
  }

  ngOnDestroy(): void {
    console.log('*** ProductListComponent in ngOnDestroy: ' + JSON.stringify(this.rows))

    localStorage.setItem(this.state + '-columns', JSON.stringify(this.selectedColumns));
    localStorage.setItem(this.state + '-obsoleted', JSON.stringify(this.showObsoleteProducts));
    localStorage.setItem(this.state + '-rows', JSON.stringify(this.rows));

    this.destroy$.next();
    this.destroy$.complete();
  }

  loadProducts(event) {
    console.log('*** ProductListComponent in loadProducts: ' + JSON.stringify(event));
    //in a real application, make a remote request to load data using state metadata from event
    //event.first = First row offset
    //event.rows = Number of rows per page
    //event.sortField = Field name to sort with
    //event.sortOrder = Sort order as number, 1 for asc and -1 for dec
    //filters: FilterMetadata object having field as key and filter value, filter matchMode as value

    // environment.production || console.table(event.filters);
    //console.log('*** ProductListComponent in loadProducts');

    this.rows = event.rows;

    if (this.virtualList) {
      console.log('*** ProductListComponent in loadProducts: virtualList length: ' + this.virtualList.length);

      if (event.sortField) {
        // environment.production || console.table(this.virtualList);
        this.productList = this.virtualList.sort((a, b) => (
          ((a[event.sortField] || '') > (b[event.sortField] || '')) ? 1 : (((a[event.sortField] || '') < (b[event.sortField] || '')) ? -1 : 0)) * event.sortOrder)
          .slice(event.first, event.first + event.rows);
      } else {
        this.productList = this.virtualList.slice(event.first, event.first + event.rows);
      }
    }
  }

  loadPage(first: number, rows: number) {
    console.log('*** ProductListComponent in loadPage: f=(' + first + '), r=(' + rows + ')');
    this.productList = this.virtualList.slice(first, first + rows);
    this.prodTable.first = first;
  }

  createProductSubscription() {

    this._productQuery =

      this.listOptions$.pipe(
        takeUntil(this.destroy$),
        debounceTime(200),
        switchMap((options: any) => {

          console.log('*** ProductListComponent in createProductSubscription: pgn=(' + options.group + ')');
          let getoptions: ProductListFetchParams = {
            mc: this.uahCurrencyId,
            bc: options.balCurr,
            fd: new Date(),
            fs: ((this.showObsoleteProducts.length) ? { "PRODOBSOLETE": { "value": JSON.stringify(this.showObsoleteProducts), "matchMode": "in" } } : {}),
            stock1: this.globalSettinsData.mainStockId,
            stock2: this.globalSettinsData.impCountFlag ? this.globalSettinsData.impStockId : 0,
            stock3: this.globalSettinsData.auxCountFlag ? this.globalSettinsData.auxStockId : 0,
          };

          if (this.prodTable) {
            //console.log('*** ProductListComponent in createProductSubscription: before spread prodtable filter' + JSON.stringify( getoptions));
            getoptions = {
              ...getoptions,
              sp: {
                sf: this.prodTable.sortField,
                so: this.prodTable.sortOrder
              },
              fs: { ...getoptions.fs, ...this.prodTable.filters }
            }
            //console.log('*** ProductListComponent in createProductSubscription: before after spread prodtable filter' + JSON.stringify(getoptions));
          }

          if (this.filters) {
            //console.log('*** ProductListComponent in createProductSubscription: before after spread filters filter' + JSON.stringify(getoptions));
            getoptions = {
              ...getoptions,
              fs: { ...getoptions.fs, ...this.filters }
            }
            //console.log('*** ProductListComponent in createProductSubscription: before after spread filters filter' + JSON.stringify(getoptions));
          }

          console.log('*** ProductListComponent in createProductSubscription: finally getoptions: ' + JSON.stringify(getoptions));

          this.loading = true;
          this.contentReady.emit(false);

          //          return this.prodApi.getProductsByGroupEx(options.group, getoptions).pipe(map(data => {

          return this.prodApi.getProductsByGroupExFull(options.group, getoptions).pipe(

            map(data => {

              this.virtualList = data;
              this.totalRecords = data.length;

              if (this.prodId) {
                this.scrollToProductId(this.prodId);
              } else {
                //this.loadPage(1, this.rows);
                this.loadPage(0, this.prodTable.rows);
              }
              this.loading = false;
            }),

            catchError(err => {
              console.error('*** ProductListComponent getProductsByGroupExFull error: ', err);
              this.loading = false;
              this.contentReady.emit(true);
              this.messageService.add({ severity: 'error', summary: 'Помилка завантаження', detail: err?.message || 'Невідома помилка' });
              return EMPTY;
            }),

            finalize(() => {
              //            environment.production || console.table(this.virtualList);

              // this.progress = 0;
              this.allProductList.emit(this.virtualList);
              this.contentReady.emit(true);
            })

          );

        })).subscribe({
          error: (err) => {
            console.error('*** ProductListComponent listOptions$ subscription error: ', err);
            this.messageService.add({ severity: 'error', summary: 'Помилка завантаження', detail: err?.message || 'Невідома помилка' });
            this.loading = false;
          }
        });
  }

  private restoreStateFromStorage(): void {
    let storedColumns: string = localStorage.getItem(this.state + '-columns');
    if (storedColumns) {
      this.selectedColumns = JSON.parse(storedColumns);
    } else {
      this.columns.forEach(e => {
        if (e.show) {
          this.selectedColumns.push(e);
          console.log(e);
        }
      });
    }

    let showObsoleted: string = localStorage.getItem(this.state + '-obsoleted');
    console.log('*** ProductListComponent restoreStateFromStorage: showObsoleted: ' + showObsoleted);
    if (showObsoleted) {
      this.showObsoleteProducts = JSON.parse(showObsoleted);
    }

    let showRows: string = localStorage.getItem(this.state + '-rows');
    console.log('*** ProductListComponent restoreStateFromStorage: showRows: ' + showRows);
    if (showRows) {
      this.rows = JSON.parse(showRows);
    }
  }

  ngOnInit(): void {
    console.log('*** ProductListComponent in ngOnInit');

    this.globalSettinsData = this.globalsettingsservice.getGlobalSettings();

    this.filterService.register('gtOrZero', (value: number, filter: number) => (
          ((filter == 0) && (value == 0)) || ((filter > 0) && (value > filter))
        )
      );

    this.restoreStateFromStorage();

    this.createProductSubscription();

    this.initialized = true;
    this.listOptions$.next({ obsolete: this.showObsoleteProducts, balCurr: this.usdCurrencyId, group: this.groupId, filter: this.filters });

  }

  onColumnSelection(event) {
    console.log('*** ProductListComponent onColumnSelection: ' + JSON.stringify(event));
    //environment.production || console.table(this.selectedColumns);
  }

  onCurrencyChange(event) {
    console.log('*** ProductListComponent onCurrencyChange: ' + JSON.stringify(event));

    if (event && ('CURID' in event)) {
      this.usdCurrencyId = event.CURID;
      this.usdCurrencyIdChange.emit(this.usdCurrencyId);
      this.listOptions$.next({ obsolete: this.showObsoleteProducts, balCurr: this.usdCurrencyId, group: this.groupId, filter: this.filters });
    }
  }

  filterProdTable(event) {
    console.log('*** ProductListComponent filterProdTable: ' + JSON.stringify(event.filters));
    this.listOptions$.next({ obsolete: this.showObsoleteProducts, balCurr: this.usdCurrencyId, group: this.groupId, filter: event.filters });
    // this.createProductSubscription(this.groupId, 0, this.prodTable.rows);
  }

  onRowSelect(event) {
    environment.production || console.log('*** ProductListComponent onRowSelect: ' + JSON.stringify(event.data));
    environment.production || console.table(this.selectedProduct);
    this.productSelection.emit({ current: event.data, list: this.selectedProduct });
  }

  onRowUnselect(event) {
    environment.production || console.log('*** ProductListComponent onRowUnselect: ' + JSON.stringify(event.data));
    this.productSelection.emit({ current: null, list: this.selectedProduct });
  }

  clearSelection(event) {
    console.log('*** ProductListComponent clearSelection ');
    this.selectedProduct = [];
    this.productSelection.emit(null);
  }

  onHeaderCheckboxToggle(event) {
    console.log('*** ProductListComponent onHeaderCheckboxToggle ' + JSON.stringify(event));
    
    this.productSelection.emit(event.checked ? { current: this.selectedProduct[0] /*event.data*/, list: this.selectedProduct } : null);
  }

onRowExpanding(event) {
    console.log('*** ProductListComponent onRowExpanding: ' + JSON.stringify(event.data))

    //this.selectedDocumentId = event.data.DOCID;
    //this.selectedDocType = event.data.DOCTYPEID;
    //if (this.selectedDocumentId) {
    //  this.doLoadDataItems(event.data);
    //}
  }

  onStateSave(state) {
    //    console.log('*** ProductListComponent onStateSave: ' + JSON.stringify(state));
  }

  onStateRestore(state) {
    //console.log('*** ProductListComponent onStateRestore: ' + JSON.stringify(state));

    if (state.filters) {
      this.filters = state.filters;

      for (let f in state.filters) {
        let fltItem = state.filters[f];
        let fltValue = Array.isArray(fltItem) ? fltItem[0].value : fltItem.value;

        switch (f) {

          case 'PRODCODE': this.prodCodeFilter = fltValue; break;

          case 'PRODBARCODEMASK': this.barCodeFilter = fltValue; break;

          case 'PRODCUSTCODE': this.custCodeFilter = fltValue; break;

          case 'PRODNAME': this.prodNameFilter = fltValue; break;

          case 'PRODARTICUL': this.prodArticulFilter = fltValue; break;

          case 'PRODDESCRIPTION': this.prodDescFilter = fltValue; break;

          case 'PRODNOTE': this.prodNoteFilter = fltValue; break;

          case 'PRODCATEGORY': this.prodCategoryFilter = fltValue; break;

          case 'PRODGROUPNAME': this.prodGroupFilter = fltValue; break;

          case 'PRODVENDORNAME': this.prodVendorFilter = fltValue; break;

          case 'PRODPRICEUAH': this.prodPriceUahFilter = fltValue; break;

          case 'PRODPRICEUSD': this.prodPriceUsdFilter = fltValue; break;

          case 'PRODSTOCK': this.prodStockBeFilter = fltValue; break;

          case 'global':
//            this.documentGlobalFilter = fltValue;
            break;

          default:
            console.log(JSON.stringify(f));
        }
      }
    }

    if (state.rows) {
      this.rows = state.rows;
    }

    if (state.selection) {
      this.selectedProduct = state.selection || [];
      //console.log('*** DocumentsComponent onStateRestore: state.selection ===> ' + JSON.stringify(this.selectedProduct));
    }

    //for (let doc in state.expandedRowKeys) {
    //  if (state.expandedRowKeys[doc]) {
    //    console.log('*** DocumentsComponent onStateRestore: expandedRowKeys ===> ' + JSON.stringify(state.expandedRowKeys[doc]));
    //    this.doLoadDataItemsByID(Number(doc));
    //  }
    //}
  }

  clearOrResetTableFilter(event) {
    console.log('*** ProductListComponent clearOrResetTableFilter: ' + JSON.stringify(event));

//    this.prodTable.filters = [];

    this.selectedProduct = [];
    this.prodId = null;
    this.filters = null;
    this.showObsoleteProducts = [0,1];

    this.prodCodeFilter =
    this.prodNameFilter =
    this.prodArticulFilter =
    this.prodDescFilter =
    this.prodNoteFilter =
    this.prodGroupFilter =
    this.prodVendorFilter =
    this.barCodeFilter =
    this.custCodeFilter = '';

    this.prodPriceUahFilter =
    this.prodPriceUsdFilter =
    this.prodStockBeFilter = null;

    this.prodTable.clearState();
    this.prodTable.clear();
    this.prodTable.reset();

    this.prodTable.filters = {};

    this.rows = 20;

    //console.log('*** ProductListComponent clearOrResetTableFilter: TB => ' + JSON.stringify(this.prodTable.filters));

    //for (let propName in this.prodTable.filters) {
    //  let filter = this.prodTable.filters[propName];
    //  console.log('*** ProductListComponent clearOrResetTableFilter: (' + propName + ') => ' + JSON.stringify(this.prodTable.filters[propName]));

    //}

    //console.log('*** ProductListComponent clearOrResetTableFilter: TB => ' + JSON.stringify(this.prodTable.filters));

    this.listOptions$.next({ obsolete: this.showObsoleteProducts, balCurr: this.usdCurrencyId, group: this.groupId, filter: null });
  }

  /*
   * TODO: need scrollTo selected document
   * may be play with x/y and viewport????
   *
   * */
  scrollToProduct(pi: Product) {
    console.log('*** ProductListComponent scrollToProduct: entering ' + JSON.stringify(pi));
    let first: number = 0;
    let index: number = 0;

    if (pi) {
      index = this.virtualList.findIndex((e) => { return (e.PRODID == pi.PRODID); });
      console.log('*** ProductListComponent scrollToProduct: index found: ' + index);

      if (index >= 0) {
        console.log('*** ProductListComponent scrollToProduct: find page: ' + Math.trunc(index / this.prodTable.rows));

        first = Math.trunc(index / this.prodTable.rows) * this.prodTable.rows;
        this.selectedProduct = [ ...[pi]];

      } else {
        this.messageService.add({ severity: 'warn', summary: 'Товар не найден', detail: 'Измените настройки фильтра' });
      }
    }
    this.loadPage(first, this.prodTable.rows);
    this.prodTable.first = first;
    this.prodTable.scrollToVirtualIndex(index);
  }

  /*
   * TODO: need scrollTo selected document
   * may be play with x/y and viewport????
   *
   * */
  scrollToProductId(pid: number) {
    console.log('*** ProductListComponent scrollToProductId: entering ');
    if (((pid || 0) != 0) && this.productList) {
      this.scrollToProduct(this.virtualList.find((e) => { return (e.PRODID == pid); }));
    }
  }

  onObsoleteOptionChange(event) {
    console.log('*** ProductListComponent onObsoleteOptionChange: ' + JSON.stringify(event));
    localStorage.setItem(this.state + '-obsoleted', JSON.stringify(this.showObsoleteProducts));

    this.listOptions$.next({obsolete: this.showObsoleteProducts,balCurr: this.usdCurrencyId,group: this.groupId, filter: this.filters});
  }

  onMarkProdObsConfirmation(event) {
    console.log('*** ProductListComponent onMarkProdObsConfirmation ');

    this.loading = true;
    this._prodGrEditQuery =

      from(this.selectedProduct).pipe(

        takeUntil(this.destroy$),
        concatMap(sp => this.prodApi.putProductMainInfo({ ...sp, PRODOBSOLETE: 1 })),

        finalize(() => {
          this.selectedProduct = [];
          this.listOptions$.next({ obsolete: this.showObsoleteProducts, balCurr: this.usdCurrencyId, group: this.groupId, filter: this.filters });
          console.log('*** ProductListComponent onMarkProdObsConfirmation - in the end');
        })

      ).subscribe({
        error: (err) => {
          console.error('*** ProductListComponent onMarkProdObsConfirmation error: ', err);
          this.loading = false;
          this.messageService.add({ severity: 'error', summary: 'Помилка операції', detail: err?.message || 'Невідома помилка' });
        }
      });
  }

  doObsoleteProduct() {
    console.log('*** ProductListComponent doObsoleteProduct ');

    //environment.production || console.table(this.selectedProduct);

    this.confirmMarkProdObsDisplay = true;
  }

  onSelectedGroup(event: ProductGroup) {
    console.log('*** ProductListComponent onSelectedGroup ');

    this.loading = true;
    this._prodGrEditQuery =

      from(this.selectedProduct).pipe(

        takeUntil(this.destroy$),
        concatMap(sp => this.prodApi.putProductMainInfo({ ...sp, PRODGROUP: event.PGROUPID })),

        finalize(() => {
          this.selectedProduct = [];
          this.listOptions$.next({ obsolete: this.showObsoleteProducts, balCurr: this.usdCurrencyId, group: this.groupId, filter: this.filters });
          console.log('*** ProductListComponent onSelectedGroup - in the end');
        })

    ).subscribe({
      error: (err) => {
        console.error('*** ProductListComponent onSelectedGroup error: ', err);
        this.loading = false;
        this.messageService.add({ severity: 'error', summary: 'Помилка операції', detail: err?.message || 'Невідома помилка' });
      }
    });
  }

  doMoveProduct() {
    console.log('*** ProductListComponent doMoveProduct ');

    this.displayGS = true;
  }

  doChangeVendorProduct() {
    console.log('*** ProductListComponent doChangeVendorProduct ');

  }

  doChangeCategoryProduct() {
    console.log('*** ProductListComponent doChangeCategoryProduct ');

    this.displayGG = true;
  }

  onSelectProductCategory(event) {
    console.log('*** ProductListComponent onSelectProductCategory ' + JSON.stringify(event));

    this.loading = true;
    this._prodGrEditQuery =

      from(this.selectedProduct).pipe(

        takeUntil(this.destroy$),
        concatMap(sp => this.prodApi.putProductCategoryByID({ ...sp, PRODCATEGORY: event })),

        finalize(() => {
          this.selectedProduct = [];
          this.listOptions$.next({ obsolete: this.showObsoleteProducts, balCurr: this.usdCurrencyId, group: this.groupId, filter: this.filters });
          console.log('*** ProductListComponent onSelectProductCategory - in the end');
        })

      ).subscribe({
        error: (err) => {
          console.error('*** ProductListComponent onSelectProductCategory error: ', err);
          this.loading = false;
          this.messageService.add({ severity: 'error', summary: 'Помилка операції', detail: err?.message || 'Невідома помилка' });
        }
      });
  }

  enterCodeString() {
    console.log('*** ProductListComponent enterCodeString ');

    this.displaySC = true;
  }

  onEnterCodeString(event) {
    console.log('*** ProductListComponent onEnterCodeString ' + JSON.stringify(event));

    this.loading = true;
    this._prodGrEditQuery =

      from(this.selectedProduct).pipe(

        takeUntil(this.destroy$),
        concatMap(sp => this.prodApi.putProductMainInfo({ ...sp, PRODCUSTCODE: event })),

        finalize(() => {
          this.selectedProduct = [];
          this.listOptions$.next({ obsolete: this.showObsoleteProducts, balCurr: this.usdCurrencyId, group: this.groupId, filter: this.filters });
          console.log('*** ProductListComponent onEnterCodeString - in the end');
        })

      ).subscribe({
        error: (err) => {
          console.error('*** ProductListComponent onEnterCodeString error: ', err);
          this.loading = false;
          this.messageService.add({ severity: 'error', summary: 'Помилка операції', detail: err?.message || 'Невідома помилка' });
        }
      });
  }
}
